var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBorja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_858_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9101 29.5701C33.4301 30.2101 33.6901 30.9501 33.6901 31.8001C33.6901 32.7901 33.4501 33.6101 32.9701 34.2701C32.4901 34.9301 31.8601 35.4101 31.0701 35.7101C30.2801 36.0101 29.4301 36.1701 28.4901 36.1701H23.8501V20.5801H27.8801C29.4801 20.5801 30.7101 20.9101 31.5901 21.5601C32.4701 22.2101 32.9101 23.2001 32.9101 24.5001C32.9101 25.3201 32.7301 26.0301 32.3601 26.6501C31.9901 27.2601 31.4701 27.7401 30.8001 28.0801C31.6901 28.4301 32.4001 28.9201 32.9101 29.5601V29.5701ZM25.9401 27.4101H28.3101C29.1101 27.4101 29.7201 27.1801 30.1301 26.7201C30.5401 26.2601 30.7401 25.6701 30.7401 24.9501C30.7401 24.1601 30.5001 23.5701 30.0101 23.1801C29.5201 22.7901 28.8401 22.6001 27.9601 22.6001H25.9301V27.4101H25.9401ZM30.6401 33.6301C31.2301 33.2201 31.5201 32.6201 31.5201 31.8301C31.5201 31.0401 31.2001 30.4101 30.5601 30.0201C29.9201 29.6301 29.1501 29.4401 28.2401 29.4401H25.9301V34.2501H28.3901C29.3001 34.2501 30.0401 34.0501 30.6301 33.6401L30.6401 33.6301Z",
    fill: "",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.99 6.96988C16.99 11.1799 20.4 14.5899 24.61 14.5899C26 14.5899 27.3 14.2099 28.42 13.5599C26.14 12.2399 24.61 9.78988 24.61 6.96988C24.61 4.14988 26.14 1.69988 28.42 0.379883",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4199 0.370117C30.6999 1.69012 32.2299 4.14012 32.2299 6.96012C32.2299 9.78012 30.6999 12.2301 28.4199 13.5501C29.5399 14.2001 30.8399 14.5801 32.2299 14.5801C36.4399 14.5801 39.8499 11.1701 39.8499 6.96012",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4201 0.370117C26.1401 1.69012 24.6101 4.14012 24.6101 6.96012C24.6101 9.78012 26.1401 12.2301 28.4201 13.5501C30.7001 12.2301 32.2301 9.78012 32.2301 6.96012C32.2301 4.14012 30.7001 1.69012 28.4201 0.370117Z",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8499 49.87C39.8499 45.66 36.4399 42.25 32.2299 42.25C30.8399 42.25 29.5399 42.63 28.4199 43.28C30.6999 44.6 32.2299 47.05 32.2299 49.87C32.2299 52.69 30.6999 55.14 28.4199 56.46",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.42 56.46C26.14 55.14 24.61 52.69 24.61 49.87C24.61 47.05 26.14 44.6 28.42 43.28C27.3 42.63 26 42.25 24.61 42.25C20.4 42.25 16.99 45.66 16.99 49.87",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6101 49.8698C24.6101 52.6898 26.1401 55.1398 28.4201 56.4598C30.7001 55.1398 32.2301 52.6898 32.2301 49.8698C32.2301 47.0498 30.7001 44.5998 28.4201 43.2798C26.1401 44.5998 24.6101 47.0498 24.6101 49.8698Z",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.87 16.9902C45.66 16.9902 42.25 20.4002 42.25 24.6102C42.25 26.0002 42.63 27.3002 43.28 28.4202C44.6 26.1402 47.05 24.6102 49.87 24.6102C52.69 24.6102 55.14 26.1402 56.46 28.4202",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.46 28.4204C55.14 30.7004 52.69 32.2304 49.87 32.2304C47.05 32.2304 44.6 30.7004 43.28 28.4204C42.63 29.5404 42.25 30.8404 42.25 32.2304C42.25 36.4404 45.66 39.8504 49.87 39.8504",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.87 32.2304C52.69 32.2304 55.14 30.7004 56.46 28.4204C55.14 26.1404 52.69 24.6104 49.87 24.6104C47.05 24.6104 44.6 26.1404 43.28 28.4204C44.6 30.7004 47.05 32.2304 49.87 32.2304Z",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.47 7.54016C47.24 8.35016 46.6 8.98016 45.79 9.19016C45.71 9.21016 45.71 9.33016 45.79 9.35016C46.6 9.57016 47.23 10.2102 47.46 11.0202C47.48 11.1102 47.6 11.1102 47.62 11.0202C47.85 10.2102 48.49 9.58016 49.3 9.37016C49.38 9.35016 49.38 9.23016 49.3 9.21016C48.49 8.99016 47.86 8.35016 47.63 7.54016C47.61 7.45016 47.49 7.45016 47.47 7.54016Z",
    fill: "#87CDE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.47 46.3199C47.24 47.1299 46.6 47.7599 45.79 47.9699C45.71 47.9899 45.71 48.1099 45.79 48.1299C46.6 48.3499 47.23 48.9899 47.46 49.7999C47.48 49.8899 47.6 49.8899 47.62 49.7999C47.85 48.9899 48.49 48.3599 49.3 48.1499C49.38 48.1299 49.38 48.0099 49.3 47.9899C48.49 47.7699 47.86 47.1299 47.63 46.3199C47.61 46.2299 47.49 46.2299 47.47 46.3199Z",
    fill: "#87CDE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96988 39.8499C11.1799 39.8499 14.5899 36.4399 14.5899 32.2299C14.5899 30.8399 14.2099 29.5399 13.5599 28.4199C12.2399 30.6999 9.78988 32.2299 6.96988 32.2299C4.14988 32.2299 1.69988 30.6999 0.379883 28.4199",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.370117 28.4202C1.69012 26.1402 4.14012 24.6102 6.96012 24.6102C9.78012 24.6102 12.2301 26.1402 13.5501 28.4202C14.2001 27.3002 14.5801 26.0002 14.5801 24.6102C14.5801 20.4002 11.1701 16.9902 6.96012 16.9902",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.370117 28.4199C1.69012 30.6999 4.14012 32.2299 6.96012 32.2299C9.78012 32.2299 12.2301 30.6999 13.5501 28.4199C12.2301 26.1399 9.78012 24.6099 6.96012 24.6099C4.14012 24.6099 1.69012 26.1399 0.370117 28.4199Z",
    stroke: "#87CDE6",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36998 49.8698C9.59998 49.0598 10.24 48.4298 11.05 48.2198C11.13 48.1998 11.13 48.0798 11.05 48.0598C10.24 47.8398 9.60998 47.1998 9.37998 46.3898C9.35998 46.2998 9.23998 46.2998 9.21998 46.3898C8.98998 47.1998 8.34998 47.8298 7.53998 48.0398C7.45998 48.0598 7.45998 48.1798 7.53998 48.1998C8.34998 48.4198 8.97998 49.0598 9.20998 49.8698C9.22998 49.9598 9.34998 49.9598 9.36998 49.8698Z",
    fill: "#87CDE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36998 11.09C9.59998 10.28 10.24 9.64998 11.05 9.43998C11.13 9.41998 11.13 9.29998 11.05 9.27998C10.24 9.05998 9.60998 8.41998 9.37998 7.60998C9.35998 7.51998 9.23998 7.51998 9.21998 7.60998C8.98998 8.41998 8.34998 9.04998 7.53998 9.25998C7.45998 9.27998 7.45998 9.39998 7.53998 9.41998C8.34998 9.63998 8.97998 10.28 9.20998 11.09C9.22998 11.18 9.34998 11.18 9.36998 11.09Z",
    fill: "#87CDE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_858_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.96,
    height: 56.96,
    fill: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBorja);
export default __webpack_public_path__ + "static/media/Icon_borja.1cda6cd4151cc36b3b2121fcfa0de3cc.svg";
export { ForwardRef as ReactComponent };